import axios from 'axios';

export default {
    state: {
        signatories: [],
    },
    getters: {
        getSignatories(state) {
            return state.signatories
        },
    },
    mutations: {
        setSignatories(state, data) {
            return state.signatories = data
        },
    },
    actions: {
        signatoriesRequest(context) {
            return axios.get('/api/branches/list/signatories')
                .then(res => {
                    context.commit('setSignatories', res.data)
                })
        },
    }
}